import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  declare readonly itemTargets: HTMLInputElement[];

  toggle(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.itemTargets.forEach((element) => {
      element.checked = checked;
    });
  }

  itemChecked(): void {
    const parent = this.element.querySelector('input[type="checkbox"]') as HTMLInputElement;
    if (parent) {
      parent.checked = this.itemTargets.every((element) => element.checked);
    }
  }
}
